import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Query, graphql, compose } from "react-apollo";

import { useAuthState, useAuthDispatch } from "../Context";
import { notify } from "../generic";
import {
  resetPassword,
  setNewPasswordFromRequest
} from "../../api/queries/utilisateur.mutations";
import { getNewPasswordRequest } from "../../api/queries/utilisateur.queries";
import ForgotPasswordForm from "../components/ForgotPasswordForm";
import NewPasswordForm from "../components/NewPasswordForm";
import { Row, Col } from "react-bootstrap";

function ForgotPasswordPage(props) {
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [newPasswordAsked, setNewPasswordAsked] = useState(false);

  const location = useLocation();
  const params = useParams();

  const { requestCode = "" } = params;

  const handleForgotPassword = async e => {
    try {
      let response = await _mutateForgotPassword(e); //loginUser action makes the request and handles all the neccessary state changes

      if (!response) return;

      navigate("/login");
    } catch (error) {
      console.log({ error });
    }
  };

  const _mutateForgotPassword = async ({ email }) => {
    try {
      return props
        .resetPassword({
          variables: {
            email
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.resetPassword;

          if (type === "success") {
            setNewPasswordAsked(true);
          } else {
            setNewPasswordAsked(false);
          }
        });

      return;
    } catch (error) {
      notify("error", error.message);
    }
  };

  const handleNewPasswordFromRequest = async e => {
    try {
      let response = await _mutateSetNewPasswordRequest(e); //loginUser action makes the request and handles all the neccessary state changes

      if (!response) return;
    } catch (error) {}
  };

  const _mutateSetNewPasswordRequest = async ({ password: newPassword }) => {
    try {
      if (!requestCode || !newPassword) return;

      return props
        .setNewPasswordFromRequest({
          variables: {
            requestCode,
            newPassword
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.setNewPasswordFromRequest;

          if (type === "success") {
            notify("success", message);
            navigate("/login");
          } else {
            notify("error", message);
          }
        });

      return;
    } catch (error) {
      notify("error", error.message);
    }
  };

  let content = null;

  const expiredDemand = (
    <Row>
      <Col xs={12}>
        <h2>Demande expirée</h2>
        <p>
          La demande de réinitialisation de mot de passe doit être effectuée
          dans les 10 minutes. Merci de recommencer.
        </p>
      </Col>
      <Col xs={12}>
        <hr />
        <span>
          <a
            className="callToActionLink"
            onClick={() => navigate("/forgotPassword")}
          >
            Réessayer
          </a>
        </span>
      </Col>
    </Row>
  );

  //b85c19c4e6f400c614cb0ca5de1b63a0|1ed7de07876012868ae4289e27b35f45
  if (newPasswordAsked) {
    content = (
      <Row>
        <Col xs={12}>
          <h2>Demande transmise</h2>
          Si cette adresse e-mail est associée à un compte Penge, un email vous
          a été envoyé. Merci de le consulter.
        </Col>
        <Col xs={12}>
          <hr />
          <span>
            <a className="callToActionLink" onClick={() => navigate("/login")}>
              Retour
            </a>
          </span>
        </Col>
      </Row>
    );
  } else if (requestCode) {
    content = (
      <Query query={getNewPasswordRequest} variables={{ requestCode }}>
        {({ loading, error, data = {}, refetch }) => {
          if (loading) return null;
          if (error) return expiredDemand;

          const { getNewPasswordRequest = {} } = data;
          const { type } = getNewPasswordRequest;

          if (type !== "success") return expiredDemand;

          return (
            <NewPasswordForm handleSubmit={handleNewPasswordFromRequest} />
          );
        }}
      </Query>
    );
  } else {
    content = <ForgotPasswordForm handleSubmit={handleForgotPassword} />;
  }

  return (
    <div>
      <div className="sidenav">
        <div className="login-main-text">
          <h2>Penge</h2>
        </div>
      </div>
      <div className="main push">
        <div className="login-form">{content}</div>
      </div>
    </div>
  );
}

export default compose(
  graphql(resetPassword, {
    name: "resetPassword"
  }),
  graphql(setNewPasswordFromRequest, {
    name: "setNewPasswordFromRequest"
  })
)(ForgotPasswordPage);
